ACC.newRepairHistory = {
  repaitStructure: '',
  repairList: [],
  phColDiv: '<div class="ph-col-12 ph-float-left">',
  phFlexDiv: '<div class="ph-d-flex ph-justify-content-between">',
  phColForMobileDiv: '<div class="ph-col-12 ph-d-block ph-d-md-none">',
  repairSearchInput: 'ph-freetextsearch__input',
  textSearchData: 'ph-myrepairs-searchData',
  textLoadData: 'ph-myrepairs-data',
  pageCount: 'ph-freetextsearch__pagecount',
  repairCount: 'ph-repairload__pagecount',
  searchTitleCount: 'ph-freetextsearch__titlecount',
  searchTitle: 'ph-freetextsearch__title',
  panelHeading: 'ph-repairhistory_panelheading',
  dataPages: 'data-number-of-pages',
  dataInitiated: 'data-initiated',
  sortVal: 'creationTime',
  noSearchResult: 'ph-freetextsearch__noresult',
  dataActive: 'data-active',
  resultCount: 0,
  noRepairs: 'ph-noRepairs',
  phIntersectionObserver: 'ph-intersection-observer',
  toggleRepairStatusCls: 'ph-toggle_repairstatus',

  bindRepairHistory: function(wrapper, pageNo) {
    var searchTerm = $('.' + ACC.newRepairHistory.repairSearchInput).val();

    $.ajax({
      url: ACC.config.contextPath + 'repair-product/getRepairOrders?searchTerm=' + searchTerm + '&pageSize=5&currentPage=' + pageNo + '&sort=' + ACC.newRepairHistory.sortVal,
      type: 'GET',
      dataType: 'json',
      async: false,
      success: function(data) {
        var pageLoad = wrapper.getElementsByClassName(ACC.newRepairHistory.repairCount)[0];

        if (data) {
          if (pageLoad) {
            pageLoad.setAttribute(ACC.newRepairHistory.dataPages, data.noOfPages);
          } else {
            $('.' + ACC.newRepairHistory.pageCount).attr(ACC.newRepairHistory.dataPages, data.noOfPages);
          }

          ACC.newRepairHistory.repairList = data.repairOrderDataList;

          ACC.newRepairHistory.repairList.forEach(function(repair) {
            ACC.newRepairHistory.repairEntry(wrapper, repair);
            ACC.newRepairHistory.markOrNot(repair.repairRequestId);
            ACC.newRepairHistory.resultCount = ACC.newRepairHistory.resultCount + 1;
          });

          if (!$('.' + ACC.newRepairHistory.textSearchData).hasClass('ph-d-none')) {
            $(document).find('.' + ACC.newRepairHistory.noSearchResult).addClass('ph-d-none');
          }

          $(document).find('.' + ACC.newRepairHistory.searchTitleCount).text('(' + ACC.newRepairHistory.resultCount + ')');
        }
      },
      error: function() {
        ACC.newRepairHistory.noResult(searchTerm);
      }
    });
  },

  noResult: function(textValue) {
    if ($('.' + ACC.newRepairHistory.textSearchData).hasClass('ph-d-none')) {
      $('.' + ACC.newRepairHistory.noRepairs).show();
      $('.' + ACC.newRepairHistory.repairSearchInput).attr('disabled', 'disabled');
    } else {
      $('.' + ACC.newRepairHistory.noRepairs).hide();
      $('.' + ACC.newRepairHistory.repairSearchInput).removeAttr('disabled');
      $(document).find('.ph-freetextsearch__noresulttext').text('"' + textValue + '"');
      $(document).find('.' + ACC.newRepairHistory.noSearchResult).removeClass('ph-d-none');
    }

    $('.' + ACC.newRepairHistory.phIntersectionObserver).find('.ph-load').hide();
  },

  bindRepairSearch: function() {
    $('.ph-rephistory_searchtab .ph-freetextsearch__input').keyup($.debounce(700, false, function() {
      ACC.newRepairHistory.searchReset();

      var sTerm = $.trim($(this).val()),
          searchWrapper = document.getElementsByClassName(ACC.newRepairHistory.textSearchData)[0];

      if (sTerm === '') {
        ACC.newRepairHistory.resetWrapper();
      } else {
        ACC.newRepairHistory.showHideWrapper();

        var pageNumber = 0;

        setTimeout(function() {
          ACC.newRepairHistory.setObserver();
        }, 3000);

        ACC.newRepairHistory.bindRepairHistory(searchWrapper, pageNumber);
      }
    }));
  },

  searchReset: function() {
    $('.' + ACC.newRepairHistory.textSearchData).html('');
    $(document).find('.' + ACC.newRepairHistory.searchTitleCount).html('');
    ACC.newRepairHistory.resultCount = 0;
    $('.' + ACC.newRepairHistory.pageCount).attr(ACC.newRepairHistory.dataPages, '');
    $('.' + ACC.newRepairHistory.pageCount).attr(ACC.newRepairHistory.dataInitiated, 0);
    $('.' + ACC.newRepairHistory.searchTitle).addClass('ph-d-none');
  },

  showHideWrapper: function() {
    $('.' + ACC.newRepairHistory.searchTitle).removeClass('ph-d-none');
    $(document).find('.' + ACC.newRepairHistory.textLoadData).attr(ACC.newRepairHistory.dataActive, 'false');
    $(document).find('.' + ACC.newRepairHistory.textLoadData).addClass('ph-d-none');
    $(document).find('.' + ACC.newRepairHistory.textSearchData).removeClass('ph-d-none');
  },

  resetWrapper: function() {
    $(document).find('.' + ACC.newRepairHistory.textLoadData).attr(ACC.newRepairHistory.dataActive, 'true');
    $(document).find('.' + ACC.newRepairHistory.textLoadData).removeClass('ph-d-none');
    $(document).find('.' + ACC.newRepairHistory.textSearchData).addClass('ph-d-none');
    $(document).find('.' + ACC.newRepairHistory.noSearchResult).addClass('ph-d-none');
  },

  markOrNot: function(key) {
    var row = 'context-' + key;

    $('.' + ACC.newRepairHistory.textSearchData + ' .' + row).find('.ph-repairhistory_panelcollapse').addClass('ph-in');
  },

  repairEntry: function(wrap, data) {
    ACC.newRepairHistory.repaitStructure = '<div class="ph-col-12 context-' + data.repairRequestId + ' ph-repairhistory__container ph-mb-1 ph-float-left ph-p-0">\n' +
    '<div class="ph-repairhistory_panel ph-repairhistory_paneldefault">\n';

    ACC.newRepairHistory.repairEntryHeader(data);

    ACC.newRepairHistory.repairEntryBody(data);

    ACC.newRepairHistory.repaitStructure = ACC.newRepairHistory.repaitStructure + '</div></div>';

    wrap.insertAdjacentHTML('beforeend', ACC.newRepairHistory.repaitStructure);
  },

  repairEntryHeader: function(data) {
    var imgTag = '<img class="ph-repairreq__image thumb ph-mw-100 ph-mh-100" src="',
        noImgSrc = '/_ui/desktop/common/philipsUI/src/images/no-image-130x130.gif',
        toggleRepairStatus = $('.' + ACC.newRepairHistory.toggleRepairStatusCls).val(),
        prodName = '',
        prodRef = '',
        repairStatus = '',
        serialNum = '';

    ACC.newRepairHistory.repaitStructure = ACC.newRepairHistory.repaitStructure + '\n' +
    '<div class="ph-repairhistory_panelheading">\n' +
    '<div class="ph-repairhistory_paneltitle ph-icon-arrow-down ph-repairhistory_border ph-col-12 ph-float-left">\n' +
    '<div class="accordion-toggle ph-repairs_product_container ph-col-12 ph-float-left " aria-expanded="false">' +
    '<div class="ph-col-11 ph-col-md-12 ph-col-lg-12 ph-repairreq-product ph-float-left ph-p-0 ph-d-flex ph-align-items-center">' +
    '<div class="ph-repairreq-prodImg ph-p-0 ph-float-left">';

    if (data.productType.imageURL) {
      var imgsrc = data.productType.imageURL;

      ACC.newRepairHistory.repaitStructure = ACC.newRepairHistory.repaitStructure + '\n' +
      imgTag + imgsrc + '" data-src="' + noImgSrc + '" alt="" title="" />';
    } else {
      ACC.newRepairHistory.repaitStructure = ACC.newRepairHistory.repaitStructure + '\n' +
      imgTag + noImgSrc + '" data-src="' + noImgSrc + '" alt="" title="" />';
    }

    if (data.productType.name !== null) {
      prodName = data.productType.name;
    }

    if (data.productRef !== null) {
      prodRef = data.productRef;
    }

    if (data.serialNumber !== null) {
      serialNum = data.serialNumber;
    }

    if (data.repairStatus !== null && toggleRepairStatus === 'true') {
      repairStatus = data.repairStatus;
    }

    ACC.newRepairHistory.repaitStructure = ACC.newRepairHistory.repaitStructure + '</div>';

    ACC.newRepairHistory.repaitStructure = ACC.newRepairHistory.repaitStructure +
    '<div class="ph-repairreq-prodDetails ph-float-left ph-col-6 ph-p-0">' +
    '<p class="ph-repairreq-prodTitle">' + prodName + '</p>' +
    '<p class="ph-repairreq-prodId">' + prodRef + '</p>' +
    '<p class="ph-repairreq-prodCtn ph-mb-0">SN:' + serialNum + '</p>' +
    '</div>' +
    '<div class="ph-float-left ph-repairreq-statusdiv ph-col-4 ph-p-0">' +
    '<p class="ph-repairreq-status ph-mb-0">' + repairStatus + '</p>' +
    '</div></div></div></div></div>';
  },

  repairEntryBody: function(data) {
    ACC.newRepairHistory.repaitStructure = ACC.newRepairHistory.repaitStructure + '\n' +
    '<div class="ph-col-12 ph-repairhistory_panelcollapse  ph-repairhistory_border ph-collapse ph-float-left ph-p-0">';
    ACC.newRepairHistory.repairHistoryInfo(data);

    ACC.newRepairHistory.repairHistoryShito(data);

    ACC.newRepairHistory.repaitStructure = ACC.newRepairHistory.repaitStructure + '</div>';
  },
  trackRepairShipment: function(repairStatus, trackingUrl) {
    var trackingHtml = {
      forDesktop: '',
      forMobile: '',
      notificationText: ''
    };

    if (repairStatus.toLocaleLowerCase() === 'waiting for device') {
      trackingHtml.notificationText = ACC.newRepairHistory.phColDiv +
        '<p class="strong ph-mt-2">*Please be sure to check your email for your shiping label</p>' +
      '</div>';
    }

    if (trackingUrl) {
      trackingHtml.forDesktop = '<div class="ph-d-none ph-d-md-block ph-track-repairs">' +
        '<span>Shipped </span>' +
        '<span class="ph-repairs-tracking">' +
        '(<a href="' + trackingUrl + '" target="_blank">track</a>)' +
        '</span>' +
      '</div>';
      trackingHtml.forMobile = ACC.newRepairHistory.phColForMobileDiv +
          '<span>Shipped</span>' +
          '<span class="ph-repairs-tracking">' +
          '(<a href="' + trackingUrl + '" target="_blank">track</a>)' +
          '</span>' +
      '</div>';
    }

    return trackingHtml;
  },
  repairHistoryInfo: function(data) {
    var date = new Date(data.createdDate);
    var options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };
    var stringDate = date.toLocaleDateString('en-US', options),
        toggleRepairStatus = $('.' + ACC.newRepairHistory.toggleRepairStatusCls).val(),
        serviceNotificationNumber = '',
        trackingUrl = '',
        trackingUrlDesktop = '',
        trackingUrlMobile = '',
        poNum = '',
        repairIssueDescription = '';

    if (data.serviceNotificationNumber === '' || data.serviceNotificationNumber === null) {
      serviceNotificationNumber = 'ERROR';
    } else {
      serviceNotificationNumber = data.serviceNotificationNumber;
    }

    if (data.poNumber !== '' || data.poNumber !== null) {
      poNum = data.poNumber;
    }

    if (data.repairIssueDescription) {
      var repairOrderReasonText = $('.repairOrderReasonText').html();

      repairIssueDescription = ACC.newRepairHistory.phColDiv +
      '<span class="ph-font_color">' + repairOrderReasonText + '</span>' +
      '<span>' + data.repairIssueDescription + '</span>' +
      '</div>';
    }

    if (toggleRepairStatus === 'true' && data.repairStatus === 'Shipped') {
      trackingUrl = ACC.newRepairHistory.trackRepairShipment(data.repairStatus, data.trackingUrl);
      trackingUrlDesktop = trackingUrl.forDesktop;
      trackingUrlMobile = trackingUrl.forMobile;
    }

    ACC.newRepairHistory.repaitStructure = ACC.newRepairHistory.repaitStructure + '\n' +
    '<div class="ph-repairhistory_info">' +
    ACC.newRepairHistory.phFlexDiv +
          '<div class="ph-p-0 ph-float-left ph-px-1">' +
            '<span class="ph-font_color">Return Authorization #: </span>' +
            '<span class="strong">' + serviceNotificationNumber + '</span>' +
          '</div>' +
          trackingUrlDesktop +
        '</div>' +
        ACC.newRepairHistory.phColDiv +
            '<span class="ph-font_color">Date submitted: </span>' +
            '<span>' + stringDate + '</span>' +
        '</div>' +
        ACC.newRepairHistory.phColDiv +
            '<span class="ph-font_color">PO #: </span>' +
            '<span>' + poNum + '</span>' +
        '</div>' + repairIssueDescription +
        trackingUrlMobile +
    '</div>';
  },
  regionDisplay: function(data) {
    var isoCodeValue = '';

    if ($('.showRegion').html() === 'true' && data.shipToAddress.region && data.shipToAddress.region.isocodeShort) {
      isoCodeValue = '&nbsp;' + data.shipToAddress.region.isocodeShort;
    }

    return isoCodeValue;
  },
  repairHistoryShito: function(data) {
    var cNameTwo = '',
        cName = '',
        addressLine = '',
        town = '',
        isoCode = ACC.newRepairHistory.regionDisplay(data),
        postalCode = '',
        moreInfoMsg = '',
        waitForRepairMsg = '',
        toggleRepairStatus = $('.' + ACC.newRepairHistory.toggleRepairStatusCls).val();

    if (data.shipToAddress.companyName2 !== null) {
      cName = data.shipToAddress.companyName2;
    }

    if (data.shipToAddress.companyName !== null) {
      cNameTwo = data.shipToAddress.companyName;
    }


    if (data.shipToAddress.line1 !== null) {
      addressLine = data.shipToAddress.line1;
    }

    if (data.shipToAddress.town !== null) {
      town = data.shipToAddress.town;
    }

    if (data.shipToAddress.postalCode !== null) {
      postalCode = data.shipToAddress.postalCode;
    }

    if (toggleRepairStatus === 'true') {
      moreInfoMsg = ACC.newRepairHistory.trackRepairShipment(data.repairStatus, data.trackingUrl);
      waitForRepairMsg = moreInfoMsg.notificationText;
    }

    ACC.newRepairHistory.repaitStructure = ACC.newRepairHistory.repaitStructure + '\n' +
    '<div class="ph-col-12 ph-rephistory_shipto ph-float-left ph-p-0">' +
      '<div class="ph-col-12 ph-py-2">' +
        '<span class="strong">Shipping address</span>' +
      '</div>';

    if (data.shipToAddress !== null && data.shipToAddress !== '') {
      ACC.newRepairHistory.repaitStructure = ACC.newRepairHistory.repaitStructure + '\n' +
      ACC.newRepairHistory.phColDiv +
        '<div>' +
          '<div>' + cName + '</div>' +
          '<div>' + cNameTwo + '</div>' +
        '</div>' +
        '<div>' +
          '<div>' + addressLine + '</div>' +
          '<div>' + town + ',' + isoCode +
          '&nbsp; ' + postalCode +
          '</div>' +
        '</div>' +
      '</div>' +
      waitForRepairMsg;
    }

    ACC.newRepairHistory.repaitStructure = ACC.newRepairHistory.repaitStructure + '</div>';
  },

  loadOrders: function(wrapper, container, observer) {
    var pageLoadDiv = wrapper.getElementsByClassName('ph-repairload__pagecount')[0],
        pageLength = '',
        numberOfPages = '',
        pageLengths = '',
        initiated = '';

    if (pageLoadDiv) {
      var loadPages = pageLoadDiv.getAttribute(ACC.newRepairHistory.dataPages),
          loadInitiated = pageLoadDiv.getAttribute(ACC.newRepairHistory.dataInitiated);

      pageLength = $('.' + ACC.newRepairHistory.textLoadData).find('.' + ACC.newRepairHistory.panelHeading).length / $('.ph-repairsshown').html();
      numberOfPages = parseInt(loadPages, 10);
      initiated = parseInt(loadInitiated, 10);
    } else {
      pageLength = $('.' + ACC.newRepairHistory.textSearchData).find('.' + ACC.newRepairHistory.panelHeading).length / $('.ph-repairsshown').html();
      numberOfPages = parseInt($('.' + ACC.newRepairHistory.pageCount).attr(ACC.newRepairHistory.dataPages), 10);
      initiated = parseInt($('.' + ACC.newRepairHistory.pageCount).attr(ACC.newRepairHistory.dataInitiated), 10);
    }

    pageLengths = Math.ceil(pageLength);

    if ((initiated < pageLengths && pageLengths < numberOfPages) && (pageLengths <= numberOfPages)) {
      if (pageLoadDiv) {
        $('.' + ACC.newRepairHistory.repairCount).attr(ACC.newRepairHistory.dataInitiated, pageLengths);
      } else {
        $('.' + ACC.newRepairHistory.pageCount).attr(ACC.newRepairHistory.dataInitiated, pageLengths);
      }

      $('.ph-load').show();

      ACC.newRepairHistory.bindRepairHistory(wrapper, pageLengths);
    } else {
      $('.' + ACC.newRepairHistory.phIntersectionObserver).find('.ph-load').hide();
    }

    if (pageLengths >= numberOfPages) {
      $('.ph-load').hide();
    }

    observer.unobserve(container);
  },

  setObserver: function() {
    var container = document.querySelector('.' + ACC.newRepairHistory.phIntersectionObserver);

    function intersection() {
      var observer = new IntersectionObserver(function(entries) {
        entries.map(function(entry) {
          var isIntersecting = entry.isIntersecting;

          if (isIntersecting) {
            var repData = $('.' + ACC.newRepairHistory.textLoadData).attr(ACC.newRepairHistory.dataActive);

            if (repData === 'true') {
              var wrapperLoad = document.getElementsByClassName(ACC.newRepairHistory.textLoadData)[0];

              ACC.newRepairHistory.loadOrders(wrapperLoad, container, observer);

              observer.observe(container);
            } else {
              var wrapperSearch = document.getElementsByClassName(ACC.newRepairHistory.textSearchData)[0];

              ACC.newRepairHistory.loadOrders(wrapperSearch, container, observer);

              observer.observe(container);
            }
          }

          return true;
        }, {
          root: null,
          rootMargin: '0px',
          threshold: 0
        });
      });

      observer.observe(container);
    }

    if ('IntersectionObserver' in window) {
      intersection();
    } else {
      $.getScript(ACC.config.commonResourcePath + '/philipsUI/src/js/vendor/intersection-observer.min.js', function() {
        intersection();
      });
    }
  }
};

$(document).ready(function() {
  if ($('.ph-repairshistory_wrapper').length > 0 && !$('.ph-repairshistory_wrapper').hasClass('hidden')) {
    var pageNo = 0,
        wrapper = document.getElementsByClassName(ACC.newRepairHistory.textLoadData)[0],
        repairHistory = $('.' + ACC.newRepairHistory.textSearchData).hasClass('ph-d-none');

    ACC.newRepairHistory.bindRepairHistory(wrapper, pageNo);

    if ($('.' + ACC.newRepairHistory.repairCount).attr(ACC.newRepairHistory.dataPages) > 0 && repairHistory === true) {
      ACC.newRepairHistory.setObserver();
    }

    ACC.newRepairHistory.bindRepairSearch();
  }
});
